import { getOrgUnits } from '@web/lib/demo/utils';
export var allOrgUnits = function (input) {
    var orgUnits = getOrgUnits({});
    return orgUnits;
};
